export default __webpack_public_path__ + "static/media/more.dd3d9132.svg";